import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38ed4416"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outlet-description" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ausstieg", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Hier endet die Unterhaltung eines untergeordneten Ablaufs. An dieser Stelle führt der Chatbot die Unterhaltung auf einer höheren Ebene weiter. Dort kannst du den weiteren Verlauf steuern, indem du die Ausstiege dieses Ablaufs dort verbindest. ", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}